import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { XMLParser } from 'fast-xml-parser';
import { environment } from '../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class ExchangeConvertorService {
  
  private apiUrl = environment.apiUrl;
  private exchnageRate: number | null = null; // Initially null

  constructor(private http: HttpClient) {}

  private fetchExchangeRate(): Observable<number> {
    return this.http.get(`${this.apiUrl}/ExchangeRate/usd-try`, { responseType: 'text' }).pipe(
      map((xmlData) => {
        const parser = new XMLParser();
        const jsonData = parser.parse(xmlData);

        const currencies = jsonData.Tarih_Date.Currency;
        const usdCurrency = currencies.find(
          (currency: any) => currency.CurrencyName === 'US DOLLAR'
        );

        if (usdCurrency) {
          this.exchnageRate = parseFloat(usdCurrency.ForexBuying);
         // console.log('Exchange Rate (USD to TRY):', this.exchnageRate);
          return this.exchnageRate;
        } else {
       //   console.error('USD exchange rate not found.');
          throw new Error('USD exchange rate not found.');
        }
      }),
      catchError((error) => {
      //  console.error('Error fetching exchange rate:', error);
        return of(0); // Return 0 or any fallback value if there's an error
      })
    );
  }

  calculateDollar(price: number): Observable<number> {
    if (this.exchnageRate !== null) {
      // If the exchange rate is already fetched, calculate immediately
      return of(parseFloat((price / this.exchnageRate).toFixed(2)));
    } else {
      // Fetch the exchange rate first, then calculate
      return this.fetchExchangeRate().pipe(
        map((exchangeRate) => {
          if (exchangeRate > 0) {
            return parseFloat((price / exchangeRate).toFixed(2));
          } else {
            throw new Error('Failed to fetch exchange rate.');
          }
        })
      );
    }
  }
}
